export default __webpack_public_path__ + "static/media/tesla clone.f816979f.png";